"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/**
 * The useClickOutside hook is designed to detect clicks that occur outside of a specified element.
 * It provides a convenient way to trigger a function when a user clicks anywhere outside a particular
 * component or element.
 * @param ref
 * @param onClickOutside
 */
const useClickOutside = (ref, onClickOutside) => {
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                onClickOutside();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, onClickOutside]);
};
exports.default = useClickOutside;
//# sourceMappingURL=useClickOutside.js.map